import { Controller } from '@hotwired/stimulus'

// I-UXC-documents-3: a kind in the „Neodesláno“ line marks its unsent cells of the Dokumenty matrix (order_documents/_list).
// Only a highlight: one kind at a time, pressing it again clears it. The counts and states come from the server.
export default class DocumentsMatrixController extends Controller<HTMLElement> {
  static classes = ['highlight']
  declare readonly highlightClasses: string[]

  highlight(event: Event): void {
    const button = event.currentTarget as HTMLButtonElement
    const pressed = button.getAttribute('aria-pressed') !== 'true'
    this.element.querySelectorAll<HTMLButtonElement>('button[aria-pressed]').forEach((other) => other.setAttribute('aria-pressed', 'false'))
    button.setAttribute('aria-pressed', String(pressed))
    this.element.querySelectorAll<HTMLElement>('[data-document][data-state]').forEach((cell) => {
      const match = pressed && cell.dataset['document'] === button.dataset['kind'] && cell.dataset['state'] !== 'sent'
      this.highlightClasses.forEach((name) => cell.classList.toggle(name, match))
    })
  }
}
